export enum ApiHeaders {
  AccessToken = "x-aigirls-access-token"
}
